import type { TopPrize } from '@/api/worldCup';
import { ChartCard } from '../ui/ChartCard';
import styles from './style.module.css';

const numFmt = new Intl.NumberFormat('en-US');

type Props = {
  prizes: TopPrize[];
  brandColors: Record<string, string>;
};

export function TopPrizesList({ prizes, brandColors }: Props) {
  // Defensive: `LOSE` is the no-reward outcome from the source DocDB prize collection.
  // The pipeline filters it out already; this is belt-and-braces in case it slips through.
  // `name` may also be null when the prize's category doesn't map to a sponsor — France
  // ships those as "unmapped" rows; show them with a neutral placeholder label.
  const visible = prizes.filter((p) => p.name !== 'LOSE');
  const max = visible.reduce((m, p) => Math.max(m, p.won), 0) || 1;
  return (
    <ChartCard title="Top prizes issued">
      <ul className={styles.list}>
        {visible.map((p, idx) => {
          const fill = p.brand_id ? (brandColors[p.brand_id] ?? 'var(--accent-2)') : 'var(--accent-2)';
          const display = p.name ?? '— unmapped —';
          // Fall back to index when name is null AND brand_id is null (no stable key).
          const key = p.name ?? p.brand_id ?? `row-${idx}`;
          return (
            <li key={key} className={styles.row}>
              <span className={`${styles.name} mono`}>{display}</span>
              <div className={styles.track} aria-hidden>
                <div className={styles.fill} style={{ width: `${(p.won / max) * 100}%`, background: fill }} />
              </div>
              <span className={`${styles.value} mono`}>{numFmt.format(p.won)}</span>
            </li>
          );
        })}
      </ul>
    </ChartCard>
  );
}
